import { gql } from "apollo-angular";
import CertificatedOutlet from "../../../interfaces/certificated-outlet";
import ID from "../../../types/id";

type CreateCertificatedOutletResults = {
  createCertificatedOutlet:CertificatedOutlet;
}
type CreateCertificatedOutletVariables = {
  organization_id: ID;
}
export const CREATE_CERTIFICATED_OUTLET = gql<CreateCertificatedOutletResults, CreateCertificatedOutletVariables>`
    mutation createCertificatedOutlet($organization_id: ID!){
      createCertificatedOutlet(input:{organization_id:$organization_id}){
        id
      }
    }
`;

export const CERTIFICATED_OUTLETS = gql`
    query certificatedOutlets{
      certificatedOutlets {
        id
        organization {
          id
          name
          entity {
            entity_types {
              type {
                name
                id
                tagType {
                  name
                }
              }
            }
          }
        }
      }
    }
`
